// --- Deduplicated Meta Event Tracker (Netlify-safe, Shopify OS 2.0) ---
window.metaEventsFired = window.metaEventsFired || {};

function fireMetaEvent(eventName, customData) {
  // Prevent duplicate events per page
  if (window.metaEventsFired[eventName]) return;
  window.metaEventsFired[eventName] = true;

  // Grab FBP/FBC from cookies / URL
  const getCookie = (name) => {
    const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    return match ? match[2] : '';
  };

  const getParam = (name) => {
    try {
      const urlParams = new URL(window.location.href).searchParams;
      return urlParams.get(name) || '';
    } catch (e) {
      return '';
    }
  };

  const fbp = getCookie('_fbp') || undefined;
  const fbclid = getParam('fbclid') || undefined;
  const fbc = fbclid ? `fb.1.${Math.floor(Date.now() / 1000)}.${fbclid}` : undefined;

  // Fire client-side Meta Pixel only
  if (typeof fbq === 'function') {
    fbq('track', eventName, customData || {});
  }
}

// --- Event Bindings ---

// Add to Cart
const addToCartForms = document.querySelectorAll('form[action^="/cart/add"]');
addToCartForms.forEach((form) => {
  form.addEventListener('submit', () => {
    fireMetaEvent('AddToCart', {});
  });
});

// Initiate Checkout
const checkoutElements = document.querySelectorAll('form[action^="/checkout"], a[href^="/checkout"]');
checkoutElements.forEach((el) => {
  el.addEventListener('click', () => {
    fireMetaEvent('InitiateCheckout');
  });
});

// Add Payment Info — only on checkout payment page
if (window.location.pathname.includes('/checkouts/') &&
    document.getElementById('checkout_payment_gateway')) {
  fireMetaEvent('AddPaymentInfo');
}
